
import React from "react";
import { TabsContent } from "@/components/ui/tabs";
import AccountsTable from "@/components/admin/account-table/AccountsTable";
import { Account, LeadAccount, StrategyWithDetails } from "@/types/strategy-types";

interface AccountsTabProps {
  accounts: Account[];
  leadAccounts: LeadAccount[];
  strategies: StrategyWithDetails[];
  createAccount: (account: Partial<Account>) => Promise<void>;
  updateAccount: (id: string, account: Partial<Account>) => Promise<void>;
  deleteAccount: (id: string) => Promise<void>;
  toggleAccountActive: (id: string, active: boolean) => Promise<void>;
  userRole?: string | null;
}

const AccountsTab = ({
  accounts,
  leadAccounts,
  strategies,
  createAccount,
  updateAccount,
  deleteAccount,
  toggleAccountActive,
  userRole
}: AccountsTabProps) => {
  return (
    <TabsContent value="accounts">
      <AccountsTable 
        accounts={accounts}
        leadAccounts={leadAccounts}
        strategies={strategies}
        onCreateAccount={createAccount}
        onUpdateAccount={updateAccount}
        onDeleteAccount={deleteAccount}
        onToggleActive={toggleAccountActive}
        userRole={userRole}
      />
    </TabsContent>
  );
};

export default AccountsTab;
